import {Expose, Type} from 'class-transformer';
import { PlanningParameter } from '../planning-parameter/planning-parameter';
import { ForecastDetail } from '../forecast-detail/forecast-detail';
import {ForecastRevision} from '../forecast-revision/forecast-revision';

export class Forecast {
    @Expose({name: '@id'})
    public readonly iri!: string;

    public readonly id!: string;
    public readonly month!: number;
    public readonly year!: number;
    public readonly status!: string;
    public readonly requestedQuantity!: number;
    public readonly latestRevisedQuantity!: number | null;

    @Type(() => ForecastDetail)
    public forecastDetails!: ForecastDetail[];

    @Type(() => PlanningParameter)
    public readonly planningParameter!: PlanningParameter;

    @Type(() => ForecastRevision)
    public readonly forecastRevisions!: ForecastRevision[];
}
